import { Injectable } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class StripeBrowserService {

  constructor(private iab: InAppBrowser,
    private platform: Platform) { }

  // open the stripe website using the in-app browser on mobile
  // on android and ios, this method will block until either the browser
  // is closed or the optional successUrl is loaded
  // on web this method will open a new tab and return straight away
  // returns true if the successUrl was loaded, otherwise false
  async openStripe(url: string, successUrl?: string): Promise<boolean> {
    if (this.platform.is('hybrid')) {
      return this.openStripeInApp(url, successUrl)
    }
    else {
      // on a webapp the in-app-browser is not available and it just uses
      // the system browser, which we can't monitor or wait for
      this.iab.create(url, '_system')
      return false
    }
  }

  private async openStripeInApp(url: string, successUrl?: string): Promise<boolean> {
    // this approach works on both android and ios
    return new Promise(async (resolve, reject) => {
      console.debug('IAB opening', url)
      let success = false
      const b = this.iab.create(url, '_blank', {
        location: 'yes', //show the location bar so there is a close button
        toolbarposition: 'top', //for ios. Android is already on the top
        //hidenavigationbuttons: 'yes', //hide the back/forward buttons
        hideurlbar: 'yes', //hide the URL
        closebuttoncaption: '< Back to Charge HQ',
        toolbarcolor: '#566573',
        closebuttoncolor: '#FFFFFF',
        navigationbuttoncolor: '#FFFFFF',
        //clearcache: 'yes', //not important in this case?
      })
      if (successUrl) {
        console.debug('IAB looking for success url', successUrl)
        b.on('loadstart').subscribe(async (v) => {
          console.debug(`IAB loadstart url=${v.url}`)
          // look for the success url and close the browser
          const match = v.url.match(successUrl)
          if (match) {
            console.debug('IAB found success url')
            success = true
            // close the browser and the exit handler will resolve the promise
            b.close()
          }
        })
      }
      b.on('exit').subscribe(v => {
        console.debug('IAB exit - success', success)
        return resolve(success)
      })
      // TODO handle errors in the webview
    })
  }

  // private async openStripeAndroid(url: string, successUrl?: string): Promise<boolean> {
  //   return new Promise(async (resolve, reject) => {
  //     console.debug('IAB opening', url)
  //     let success = false
  //     const b = this.iab.create(url, '_blank', {
  //       beforeload: 'yes', //enable the beforeload event as required to intercept the redirect on newer versions of webview
  //       //clearcache: 'yes', //FIXME review this
  //     })
  //     if (successUrl) {
  //       console.debug('IAB looking for success url', successUrl)
  //       b.on('beforeload').subscribe(async (v) => {
  //         console.debug(`IAB loadstart url=${v.url}`)
  //         // look for the success url and close the browser
  //         const match = v.url.match(successUrl)
  //         if (match) {
  //           console.debug('IAB found success url')
  //           success = true
  //           // close the browser and the exit handler will resolve the promise
  //           b.close()
  //         }
  //         else {
  //           // for any other url we have to allow it to load, since we enabled beforeload event
  //           // This is not actually used I think, but let's leave it just in case
  //           console.log('IAB allowing url to load: '+v.url)
  //           b._loadAfterBeforeload(v.url)
  //         }
  //       })
  //     }
  //     b.on('exit').subscribe(v => {
  //       console.debug('IAB exit - success', success)
  //       return resolve(success)
  //     })
  //     // TODO handle errors in the webview
  //   })
  // }
}
